import { useMutation } from '@tanstack/react-query'
import { axiosPatch } from 'Redux/axiosHelper'
import { AdditionalFeePayload } from 'types/event/eventStep3'

// add more fee
const addMoreFee = async ({
  leagueId,
  payload,
}: {
  leagueId: string
  payload: AdditionalFeePayload
}) => {
  const response = await axiosPatch(
    payload,
    `v1/league/${leagueId}/add-more-fee`,
  )
  return response.data
}

export const useAddMoreFee = () => {
  return useMutation(addMoreFee)
}

// edit more fee
const editMoreFee = async ({
  leagueId,
  feeId,
  payload,
}: {
  leagueId: string
  feeId: string
  payload: AdditionalFeePayload
}) => {
  const response = await axiosPatch(
    payload,
    `v1/league/${leagueId}/edit-more-fee/${feeId}`,
  )
  return response.data
}

export const useEditMoreFee = () => {
  return useMutation(editMoreFee)
}

// delete more fee
const deleteMoreFee = async ({
  leagueId,
  feeId,
}: {
  leagueId: string
  feeId: string
}) => {
  const response = await axiosPatch(
    {},
    `v1/league/${leagueId}/delete-more-fee/${feeId}`,
  )
  return response.data
}
export const useDeleteMoreFee = () => {
  return useMutation(deleteMoreFee)
}

//cost and fee for league
const costAndFeeForLeague = async ({ leagueId, payload }) => {
  const response = await axiosPatch(payload, `v1/league/step-6/${leagueId}`)
  return response.data
}

export const useCostAndFeeForLeague = () => {
  return useMutation(costAndFeeForLeague)
}
